/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_Back_To_LoginInputs */



/**
* | output |
* | --- |
* | "Back to Login" |
*
* @param {Auth_Sso_Back_To_LoginInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_back_to_login = /** @type {((inputs?: Auth_Sso_Back_To_LoginInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_Back_To_LoginInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zur Anmeldung")
	return /** @type {LocalizedString} */ ("Back to Login")
});